import * as React from 'react';
import { useTheme } from '../../../../theming/useTheme';
import { DividedCardComponent, DIVIDED_CARD_TYPES, CardComponentDataProps } from '../dividedCard/DividedCard';
import { VrLineHeight } from '../../../../theming/verticalRhythm/verticalRhythm';

const numberOfLines = 3;
const componentConfigThemeKey = 'horizontalCard';

interface HorizontalCardThemeProps {
  cardBackgroundColor: string
  cardTextColor: string
  cardTextTypography: string
  surfaceStyle: any
  cardDecorationColor: string
  vrLineHeight: VrLineHeight
}

type Props = CardComponentDataProps & HorizontalCardThemeProps;

const mapThemeProps = (theme: HorizontalCardThemeProps): HorizontalCardThemeProps => {
  return {
    cardBackgroundColor: theme.cardBackgroundColor,
    cardTextColor: theme.cardTextColor,
    cardTextTypography: theme.cardTextTypography,
    surfaceStyle: theme.surfaceStyle,
    cardDecorationColor: theme.cardBackgroundColor,
    vrLineHeight: theme.vrLineHeight,
  };
};

const HorizontalCardComponent = (props: Props) => (
  <DividedCardComponent
    {...props}
    dividedCardType={DIVIDED_CARD_TYPES.HORIZONTAL}
    numberOfLines={numberOfLines}
  />
);

export const HorizontalCard = (props: CardComponentDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <HorizontalCardComponent {...themeContext} {...props} />;
};
